import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { CreateEndpointRequest, IntegrationEndpointDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/endpoints — 엔드포인트 생성 (INTEGRATION_MANAGE)
 */
export function useCreateEndpoint() {
  const queryClient = useQueryClient();
  return useMutation<IntegrationEndpointDto, { code: string; message: string }, CreateEndpointRequest>({
    mutationFn: (req) => integrationHubApi.createEndpoint(req),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'endpoints'] });
    },
  });
}
